const createForm = {
  basic: {
    name: {
      get() {
        console.log(this.action);
        return this.$store.state.InventoryModule.Products[this.action].basic.name;
      },
      set(value) {
        this.$store.commit('InventoryModule/Products/setProductProperty', {
          action: this.action, parent: 'basic', child: 'name', payload: value,
        });
      },
    },
    description: {
      get() {
        return this.$store.state.InventoryModule.Products[this.action].basic.description;
      },
      set(value) {
        this.$store.commit('InventoryModule/Products/setProductProperty', {
          action: this.action, parent: 'basic', child: 'description', payload: value,
        });
      },
    },
    extra_description: {
      get() {
        return this.$store.state.InventoryModule.Products[this.action].basic.extra_description || '';
      },
      set(value) {
        this.$store.commit('InventoryModule/Products/setProductProperty', {
          action: this.action, parent: 'basic', child: 'extra_description', payload: value,
        });
      },
    },
    cost: {
      get() {
        return this.$store.state.InventoryModule.Products[this.action].basic.cost;
      },
      set(value) {
        this.$store.commit('InventoryModule/Products/setProductProperty', {
          action: this.action, parent: 'basic', child: 'cost', payload: value,
        });
      },
    },
    price: {
      get() {
        return this.$store.state.InventoryModule.Products[this.action].basic.price;
      },
      set(value) {
        this.$store.commit('InventoryModule/Products/setProductProperty', {
          action: this.action, parent: 'basic', child: 'price', payload: value,
        });
      },
    },
    discount: {
      get() {
        return this.$store.state.InventoryModule.Products[this.action].basic.discount;
      },
      set(value) {
        this.$store.commit('InventoryModule/Products/setProductProperty', {
          action: this.action, parent: 'basic', child: 'discount', payload: value,
        });
      },
    },
    vat: {
      get() {
        return this.$store.state.InventoryModule.Products[this.action].basic.vat;
      },
      set(value) {
        this.$store.commit('InventoryModule/Products/setProductProperty', {
          action: this.action, parent: 'basic', child: 'vat', payload: value,
        });
        const amount = (this.price * (value / 100)).toFixed(2);
        this.$store.commit('InventoryModule/Products/setProductProperty', {
          action: this.action, parent: 'basic', child: 'vat_amount', payload: amount,
        });
      },
    },
    weight: {
      get() {
        return this.$store.state.InventoryModule.Products[this.action].basic.weight;
      },
      set(value) {
        this.$store.commit('InventoryModule/Products/setProductProperty', {
          action: this.action, parent: 'basic', child: 'weight', payload: value,
        });
      },
    },
    status: {
      get() {
        return this.$store.state.InventoryModule.Products[this.action].basic.status;
      },
      set(value) {
        this.$store.commit('InventoryModule/Products/setProductProperty', {
          action: this.action, parent: 'basic', child: 'status', payload: value,
        });
      },
    },
    on_sale: {
      get() {
        return this.$store.state.InventoryModule.Products[this.action].basic.on_sale;
      },
      set(value) {
        this.$store.commit('InventoryModule/Products/setProductProperty', {
          action: this.action, parent: 'basic', child: 'on_sale', payload: value,
        });
      },
    },
    require_shipping: {
      get() {
        return this.$store.state.InventoryModule.Products[this.action].basic.require_shipping;
      },
      set(value) {
        this.$store.commit('InventoryModule/Products/setProductProperty', {
          action: this.action, parent: 'basic', child: 'require_shipping', payload: value,
        });
      },
    },
    vatable: {
      get() {
        return this.$store.state.InventoryModule.Products[this.action].basic.vatable;
      },
      set(value) {
        this.$store.commit('InventoryModule/Products/setProductProperty', {
          action: this.action, parent: 'basic', child: 'vatable', payload: value,
        });
      },
    },
    homepage_feature: {
      get() {
        return this.$store.state.InventoryModule.Products[this.action].basic.homepage_feature;
      },
      set(value) {
        this.$store.commit('InventoryModule/Products/setProductProperty', {
          action: this.action, parent: 'basic', child: 'homepage_feature', payload: value,
        });
      },
    },
    dimension: {
      get() {
        return this.$store.state.InventoryModule.Products[this.action].basic.dimension;
      },
      set(value) {
        this.$store.commit('InventoryModule/Products/setProductProperty', {
          action: this.action, parent: 'basic', child: 'dimension', payload: value,
        });
      },
    },

  },
};

export default createForm;
